export const createRequest = (url, method, body, additionalHeaders) => {
  const headersObj = createHeaders(additionalHeaders);
  const options = createOptions({ method: method }, headersObj, createBody(body));
  return new Request(url, options);
};

const createBody = body => ({ body: JSON.stringify(body) });

const createOptions = (...options) => options.reduce((prev, next) => ({ ...prev, ...next }), { cache: 'no-cache' });

const createHeaders = (headers = {}) => ({
  headers: { ...headers, 'Content-Type': 'application/json' }
});
